/* eslint no-param-reassign: 0 */
import * as types from '../mutation-types';
import WgptIntegrationsAPI from 'dashboard/api/wgpt/integrations';
import { throwErrorMessage } from 'dashboard/store/utils/api';

const state = {
  records: [],
  zidWebhooks: [],
  uiFlags: {
    isFetchingZidWebhooks: false,
    isUpdatingSalla: false,
    isDeletingSalla: false,
    isUpdatingZid: false,
    isDeletingZid: false,
    isUpdatingHook: false,
  },
};

export const getters = {
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getZidWebhooks($state) {
    return $state.zidWebhooks;
  },
};

export const actions = {
  getZidWebhooks: async ({ commit }) => {
    commit(types.default.SET_WGPT_INTEGRATIONS_UI_FLAG, {
      isFetchingZidWebhooks: true,
    });
    try {
      const { data } = await WgptIntegrationsAPI.listZidWebhookSubscriptions();
      commit(types.default.SET_WGPT_INTEGRATIONS_ZID_WEBHOOKS, data);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.default.SET_WGPT_INTEGRATIONS_UI_FLAG, {
        isFetchingZidWebhooks: false,
      });
    }
  },
  updateSalla: async ({ commit }, sallaObj) => {
    commit(types.default.SET_WGPT_INTEGRATIONS_UI_FLAG, {
      isUpdatingSalla: true,
    });
    try {
      const response = await WgptIntegrationsAPI.updateSalla(sallaObj);

      const { app_id: appId, id: hookId } = response.data;
      commit(
        'integrations/DELETE_INTEGRATION_HOOKS',
        { appId, hookId },
        { root: true }
      );
      commit('integrations/ADD_INTEGRATION_HOOKS', response.data, {
        root: true,
      });
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.default.SET_WGPT_INTEGRATIONS_UI_FLAG, {
        isUpdatingSalla: false,
      });
    }
  },
  updateSallaSettings: async ({ commit }, settings) => {
    commit(types.default.SET_WGPT_INTEGRATIONS_UI_FLAG, {
      isUpdatingSalla: true,
    });
    try {
      const response = await WgptIntegrationsAPI.updateSallaSettings(settings);

      const { app_id: appId, id: hookId } = response.data;
      commit(
        'integrations/DELETE_INTEGRATION_HOOKS',
        { appId, hookId },
        { root: true }
      );
      commit('integrations/ADD_INTEGRATION_HOOKS', response.data, {
        root: true,
      });
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.default.SET_WGPT_INTEGRATIONS_UI_FLAG, {
        isUpdatingSalla: false,
      });
    }
  },
  updateZid: async ({ commit }, zidObj) => {
    commit(types.default.SET_WGPT_INTEGRATIONS_UI_FLAG, {
      isUpdatingZid: true,
    });
    try {
      const response = await WgptIntegrationsAPI.updateZid(zidObj);

      const { app_id: appId, id: hookId } = response.data;
      commit(
        'integrations/DELETE_INTEGRATION_HOOKS',
        { appId, hookId },
        { root: true }
      );
      commit('integrations/ADD_INTEGRATION_HOOKS', response.data, {
        root: true,
      });
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.default.SET_WGPT_INTEGRATIONS_UI_FLAG, {
        isUpdatingZid: false,
      });
    }
  },
  updateZidSettings: async ({ commit }, settings) => {
    commit(types.default.SET_WGPT_INTEGRATIONS_UI_FLAG, {
      isUpdatingZid: true,
    });
    try {
      const response = await WgptIntegrationsAPI.updateZidSettings(settings);

      const { app_id: appId, id: hookId } = response.data;
      commit(
        'integrations/DELETE_INTEGRATION_HOOKS',
        { appId, hookId },
        { root: true }
      );
      commit('integrations/ADD_INTEGRATION_HOOKS', response.data, {
        root: true,
      });
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.default.SET_WGPT_INTEGRATIONS_UI_FLAG, {
        isUpdatingZid: false,
      });
    }
  },
  updateHook: async ({ commit }, { appId, hookId, ...hookData }) => {
    commit(types.default.SET_WGPT_INTEGRATIONS_UI_FLAG, {
      isUpdatingHook: true,
    });
    try {
      const response = await WgptIntegrationsAPI.updateHook(hookId, hookData);
      // const { app_id: appId, id: hookId } = response.data;

      commit(
        'integrations/DELETE_INTEGRATION_HOOKS',
        { appId, hookId },
        { root: true }
      );
      commit('integrations/ADD_INTEGRATION_HOOKS', response.data, {
        root: true,
      });
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.default.SET_WGPT_INTEGRATIONS_UI_FLAG, {
        isUpdatingHook: false,
      });
    }
  },
  updateZidWebhookSubscription: async (
    { commit },
    { eventName, subscribed }
  ) => {
    commit(types.default.SET_WGPT_INTEGRATIONS_UI_FLAG, {
      isUpdatingZid: true,
    });
    try {
      if (subscribed) {
        await WgptIntegrationsAPI.subscribeZidWebhook(eventName);
      } else {
        await WgptIntegrationsAPI.unsubscribeZidWebhook(eventName);
      }
      commit(types.default.EDIT_WGPT_INTEGRATIONS_ZID_WEBHOOK, {
        event_name: eventName,
        subscribed,
      });
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.default.SET_WGPT_INTEGRATIONS_UI_FLAG, {
        isUpdatingZid: false,
      });
    }
  },
  addFile: async ({ commit }, { file, id, automationId }) => {
    commit(types.default.SET_WGPT_INTEGRATIONS_UI_FLAG, {
      isUpdatingSalla: true,
      isUpdatingZid: true,
    });
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('automation_id', automationId);
      const response = await WgptIntegrationsAPI.addFile(id, formData);
      const { app_id: appId, id: hookId, files } = response.data;
      commit(
        'integrations/DELETE_INTEGRATION_HOOKS',
        { appId, hookId },
        { root: true }
      );
      commit('integrations/ADD_INTEGRATION_HOOKS', response.data, {
        root: true,
      });
      return files[files.length - 1];
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.default.SET_WGPT_INTEGRATIONS_UI_FLAG, {
        isUpdatingSalla: false,
        isUpdatingZid: false,
      });
    }
    return null;
  },
};

export const mutations = {
  [types.default.SET_WGPT_INTEGRATIONS_UI_FLAG]($state, uiFlag) {
    $state.uiFlags = { ...$state.uiFlags, ...uiFlag };
  },
  [types.default.SET_WGPT_INTEGRATIONS_ZID_WEBHOOKS]($state, zidWebhooks) {
    $state.zidWebhooks = zidWebhooks;
  },
  [types.default.EDIT_WGPT_INTEGRATIONS_ZID_WEBHOOK]($state, data) {
    $state.zidWebhooks = $state.zidWebhooks.map(webhook => {
      if (webhook.event_name === data.event_name) {
        return { ...webhook, ...data };
      }
      return webhook;
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
